import { action } from 'typesafe-actions';
import { CriaAgendamentoTypes, ICriaAgendamento } from './types';

export const loadRequest = (
  codCliente: number,
  codCdd: number,
  codMotorista: number,
  ordemCarga: number,
  codTipoCarroceria: number,
  codTransportadora: number,
  codEmp: number,
  codVeiculo: number,
  dhAgendamento: string,
  assoalho: string
) =>
  action(CriaAgendamentoTypes.LOAD_REQUEST, {
    codCdd,
    codEmp,
    codCliente,
    codMotorista,
    ordemCarga,
    codTipoCarroceria,
    codTransportadora,
    codVeiculo,
    dhAgendamento,
    assoalho,
  });
export const loadSuccess = (data: ICriaAgendamento[]) =>
  action(CriaAgendamentoTypes.LOAD_SUCCESS, { data });
export const loadFailure = () => action(CriaAgendamentoTypes.LOAD_FAILURE, {});
